module.exports = "import * as React from 'react'\nimport { route, RouteProps } from '@brightinteractive/bright-js-framework'\n\nexport type UserPageParams = 'name'\n\n@route('/users/:name')\nexport class UserPage extends React.PureComponent<RouteProps<UserPageParams>> {\n  render() {\n    return <div>Hello, {this.props.pathParams.name}!</div>\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!../examples/getting-started/src/pages/UserPage.tsx
// module id = 664
// module chunks = 84779536864874